import type { CityPage } from './types';

export const useCityPages = () => {
  const list = <CityPage[]>[
    {
      name: 'berlin',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [3806],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/berlin?housingType=1&locationIds%5Bcities%5D=3806',
    },
    {
      name: 'hamburg',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [4703],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/hamburg?housingType=1&locationIds%5Bcities%5D=4703',
    },
    {
      name: 'münchen',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [2326],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/münchen?housingType=1&locationIds%5Bcities%5D=2326',
    },
    {
      name: 'köln',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [8072],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/köln?housingType=1&locationIds%5Bcities%5D=8072',
    },
    {
      name: 'frankfurt am main',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [4759],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/frankfurt-am-main?housingType=1&locationIds%5Bcities%5D=4759',
    },
    {
      name: 'stuttgart',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [1056],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/stuttgart?housingType=1&locationIds%5Bcities%5D=1056',
    },
    {
      name: 'düsseldorf',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [7960],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/düsseldorf?housingType=1&locationIds%5Bcities%5D=7960',
    },
    {
      name: 'leipzig',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [11685],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/leipzig?housingType=1&locationIds%5Bcities%5D=11685',
    },
    {
      name: 'dortmund',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [7806],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/dortmund?housingType=1&locationIds%5Bcities%5D=7806',
    },
    {
      name: 'essen',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [7961],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/essen?housingType=1&locationIds%5Bcities%5D=7961',
    },
    {
      name: 'bremen',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [4701],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/bremen?housingType=1&locationIds%5Bcities%5D=4701',
    },
    {
      name: 'dresden',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [11347],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/dresden?housingType=1&locationIds%5Bcities%5D=11347',
    },
    {
      name: 'hannover',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [7060],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/hannover?housingType=1&locationIds%5Bcities%5D=7060',
    },
    {
      name: 'nürnberg',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [1485],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/nürnberg?housingType=1&locationIds%5Bcities%5D=1485',
    },
    {
      name: 'duisburg',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [7959],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/duisburg?housingType=1&locationIds%5Bcities%5D=7959',
    },
    {
      name: 'bochum',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [7805],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/bochum?housingType=1&locationIds%5Bcities%5D=7805',
    },
    {
      name: 'wuppertal',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [8024],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/wuppertal?housingType=1&locationIds%5Bcities%5D=8024',
    },
    {
      name: 'bielefeld',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [7888],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/bielefeld?housingType=1&locationIds%5Bcities%5D=7888',
    },
    {
      name: 'bonn',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [8035],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/bonn?housingType=1&locationIds%5Bcities%5D=8035',
    },
    {
      name: 'münster',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [8154],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/münster?housingType=1&locationIds%5Bcities%5D=8154%2C32507',
    },
    {
      name: 'karlsruhe',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [409],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/karlsruhe?housingType=1&locationIds%5Bcities%5D=409',
    },
    {
      name: 'mannheim',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [433],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/mannheim?housingType=1&locationIds%5Bcities%5D=433',
    },
    {
      name: 'augsburg',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [3140],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/augsburg?housingType=1&locationIds%5Bcities%5D=3140',
    },
    {
      name: 'wiesbaden',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [4927],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/wiesbaden?housingType=1&locationIds%5Bcities%5D=4927',
    },
    {
      name: 'gelsenkirchen',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [8153],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/gelsenkirchen?housingType=1&locationIds%5Bcities%5D=8153',
    },
    {
      name: 'braunschweig',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [6673],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/braunschweig?housingType=1&locationIds%5Bcities%5D=6673',
    },
    {
      name: 'kiel',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [13263],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/kiel?housingType=1&locationIds%5Bcities%5D=13263',
    },
    {
      name: 'chemnitz',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [10943],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/chemnitz?housingType=1&locationIds%5Bcities%5D=10943',
    },
    {
      name: 'rostock',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [6358],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/rostock?housingType=1&locationIds%5Bcities%5D=6358',
    },
    {
      name: 'freiburg im breisgau',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [76],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/freiburg-im-breisgau?housingType=1&locationIds%5Bcities%5D=76',
    },
    {
      name: 'magdeburg',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [12465],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/magdeburg?housingType=1&locationIds%5Bcities%5D=12465',
    },
    {
      name: 'lübeck',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [13265],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/lübeck?housingType=1&locationIds%5Bcities%5D=13265',
    },
    {
      name: 'oldenburg',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [7726],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/oldenburg?housingType=1&locationIds%5Bcities%5D=7726',
    },
    {
      name: 'heidelberg',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [393],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/heidelberg?housingType=1&locationIds%5Bcities%5D=393',
    },
    {
      name: 'mainz',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [9970],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/mainz?housingType=1&locationIds%5Bcities%5D=9970',
    },
    {
      name: 'ingolstadt',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [2173],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/ingolstadt?housingType=1&locationIds%5Bcities%5D=2173',
    },
    {
      name: 'erfurt',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [14466],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/erfurt?housingType=1&locationIds%5Bcities%5D=14466',
    },
    {
      name: 'regensburg',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [3035],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/regensburg?housingType=1&locationIds%5Bcities%5D=3035',
    },
    {
      name: 'potsdam',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [4345],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/potsdam?housingType=1&locationIds%5Bcities%5D=4345',
    },
    {
      name: 'aachen',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [8025],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/aachen?housingType=1&locationIds%5Bcities%5D=8025',
    },
    {
      name: 'salzgitter',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [6831],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/salzgitter?housingType=1&locationIds%5Bcities%5D=6831',
    },
    {
      name: 'darmstadt',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [4732],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/darmstadt?housingType=1&locationIds%5Bcities%5D=4732',
    },
    {
      name: 'erlangen',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [1401],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/erlangen?housingType=1&locationIds%5Bcities%5D=1401',
    },
    {
      name: 'ulm',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [1313],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/ulm?housingType=1&locationIds%5Bcities%5D=1313',
    },
    {
      name: 'offenbach am main',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [4872],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/offenbach-am-main?housingType=1&locationIds%5Bcities%5D=4872',
    },
    {
      name: 'bamberg',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [2636],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/bamberg?housingType=1&locationIds%5Bcities%5D=2636',
    },
    {
      name: 'heilbronn',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [725],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/heilbronn?housingType=1&locationIds%5Bcities%5D=725',
    },
    {
      name: 'osnabrück',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [7761],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/osnabrück?housingType=1&locationIds%5Bcities%5D=7761',
    },
    {
      name: 'trier',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [10668],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/trier?housingType=1&locationIds%5Bcities%5D=10668',
    },
    {
      name: 'wolfsburg',
      countryName: 'germany',
      locationIds: {
        regions: [],
        cities: [6873],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/wolfsburg?housingType=1&locationIds%5Bcities%5D=6873',
    },
    {
      name: 'wien',
      countryName: 'austria',
      locationIds: {
        regions: [],
        cities: [38113],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/wien?housingType=1&locationIds%5Bcities%5D=38113',
    },
    {
      name: 'graz',
      countryName: 'austria',
      locationIds: {
        regions: [],
        cities: [38115],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/graz?housingType=1&locationIds%5Bcities%5D=38115',
    },
    {
      name: 'linz',
      countryName: 'austria',
      locationIds: {
        regions: [],
        cities: [25214],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/linz?housingType=1&locationIds%5Bcities%5D=25214',
    },
    {
      name: 'salzburg',
      countryName: 'austria',
      locationIds: {
        regions: [],
        cities: [30847],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/salzburg?housingType=1&locationIds%5Bcities%5D=30847',
    },
    {
      name: 'innsbruck',
      countryName: 'austria',
      locationIds: {
        regions: [],
        cities: [32374],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/innsbruck?housingType=1&locationIds%5Bcities%5D=32374',
    },
    {
      name: 'klagenfurt',
      countryName: 'austria',
      locationIds: {
        regions: [],
        cities: [38114],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/klagenfurt?housingType=1&locationIds%5Bcities%5D=38114',
    },
    {
      name: 'wels',
      countryName: 'austria',
      locationIds: {
        regions: [],
        cities: [27465],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/wels?housingType=1&locationIds%5Bcities%5D=27465',
    },
    {
      name: 'zürich',
      countryName: 'switzerland',
      locationIds: {
        regions: [],
        cities: [15526],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/zürich?housingType=1&locationIds%5Bcities%5D=15526',
    },
    {
      name: 'genf',
      countryName: 'switzerland',
      locationIds: {
        regions: [],
        cities: [17326],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/genf?housingType=1&locationIds%5Bcities%5D=17326',
    },
    {
      name: 'basel',
      countryName: 'switzerland',
      locationIds: {
        regions: [],
        cities: [16143],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/basel?housingType=1&locationIds%5Bcities%5D=16143',
    },
    {
      name: 'bern',
      countryName: 'switzerland',
      locationIds: {
        regions: [],
        cities: [16154],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/bern?housingType=1&locationIds%5Bcities%5D=16154',
    },
    {
      name: 'lausanne',
      countryName: 'switzerland',
      locationIds: {
        regions: [],
        cities: [19769],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/lausanne?housingType=1&locationIds%5Bcities%5D=19769',
    },
    {
      name: 'winterthur',
      countryName: 'switzerland',
      locationIds: {
        regions: [],
        cities: [20930],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/winterthur?housingType=1&locationIds%5Bcities%5D=20930',
    },
    {
      name: 'luzern',
      countryName: 'switzerland',
      locationIds: {
        regions: [],
        cities: [17928],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/luzern?housingType=1&locationIds%5Bcities%5D=17928',
    },
    {
      name: 'st. gallen',
      countryName: 'switzerland',
      locationIds: {
        regions: [],
        cities: [18236],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/st.-gallen?housingType=1&locationIds%5Bcities%5D=18236',
    },
    {
      name: 'lugano',
      countryName: 'switzerland',
      locationIds: {
        regions: [],
        cities: [19284],
        areas: [],
      },
      searchUrl: '/suche/wohnung-mieten/lugano?housingType=1&locationIds%5Bcities%5D=19284',
    },
  ];

  const names = list.map((city) => city.name);

  return {
    list,
    names,
  };
};
